<template>
  <div
    class="d-inline-block vertical-align-middle"
  >
    <v-img
      v-if="user.pictureUrl"
      :src="user.pictureUrl"
      cover
      alt="user picture"
      class="picture-rounded"
      :style="styleImg"
    />
    <v-img
      v-else
      :src="defaultAvatar"
      cover
      alt="default picture"
      class="picture-rounded"
      :style="styleImg"
    />
  </div>
</template>

<script>
import User from '@/models/User/user';
import defaultAvatar from '@/assets/default-avatar.png';

export default {
  name: 'ProfilePicture',
  data() {
    return {
      defaultAvatar,
    };
  },
  props: {
    user: {
      type: User,
      required: true,
    },
    width: {
      type: String,
      default: '50px',
    },
  },
  computed: {
    styleImg() {
      return `width: ${this.width}; height: ${this.width};`;
    },
  },
};
</script>

<style>
.picture-rounded {
  border-radius: 8px;
}
</style>
